import React from 'react';
import Profile from '../assets/profile.jpg';
import { MilitaryTech, SnippetFolder } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import '../styles/About.css'


function About() {
  return (
    <div id='about'>
        <h5>Get To Know</h5>
        <h2>About Me</h2>

        <div className='about_container'>
                  <div className='about_me'>
                    <div className='about_me_image'>
                        <img src={Profile} alt="" />
                    </div>
                  </div>

         
                <div className='about_content'>
                  <div className='about_cards'>
                    <article className='about_card'>
                      <MilitaryTech className='about_icon' />
                      <h5>Experience</h5>
                      <small>1+ Year Working</small>
                    </article>
                    <article className='about_card'>
                      <SnippetFolder className='about_icon' />
                      <h5>Projects</h5>
                      <small>6+ Completed</small>
                    </article>
                  </div>
                      <p>
                        I am Anyiekpon Akpan, a Front-End web Developer.
                        I love combining the worlds of logic and creative design to make eye-catching, accessible, and user-friendly websites and applications. <br />
                        <br />
                        Technology leads, society follows. The move towards increasing , inclusivity and diversity in the industry is of importance to me. <br />
                        <br />
                        I am excited to make the leap and continue refining my skills with the right company. Drop me a Message in my contact form below.
                      </p>
                  <div className='talk'>
                    <Link to='/contact' className='button_primary'>Let's Talk</Link>
                  </div>
                </div>
            
        </div>
    </div>
  )
}

export default About;